import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  layout: {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    backgroundColor: theme.palette.background.default,
    transition: "background-color 0.3s ease",
  },

  header: {
    height: "calc(64px + env(safe-area-inset-top))",
    flexShrink: 0,
    zIndex: 1100,
    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)",
    background: theme.palette.background.gradient || theme.palette.background.topheaderbg,
    backdropFilter: "blur(8px)",
    paddingTop: "env(safe-area-inset-top)",
  },

  main: {
    display: "flex",
    flex: 1,
    overflow: "hidden",
    position: "relative",
    backgroundColor: theme.palette.background.default,
  },

  // Base SideNav style
  sideNav: {
    width: "280px",
    backgroundColor: theme.palette.background.paper,
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)",
    flexShrink: 0,
    overflowY: "auto",
    overflowX: "hidden",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    borderRight: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.down("md")]: {
      position: "fixed",
      height: "calc(100% - 64px - env(safe-area-inset-top))",
      top: "calc(64px + env(safe-area-inset-top))",
      zIndex: 1300,
      left: 0,
      pointerEvents: "auto",
      touchAction: "auto",
    },
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      background: theme.palette.divider,
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: theme.palette.text.secondary,
    },
  },

  sideNavOpen: {
    transform: "translateX(0)",
    width: 280,
    opacity: 1,
    visibility: "visible",
  },

  sideNavClosed: {
    transform: "translateX(-100%)",
    opacity: 0,
    visibility: "hidden",
    borderRight: "none",
    [theme.breakpoints.up("md")]: {
      width: 0,
      overflow: "hidden",
    },
    [theme.breakpoints.down("md")]: {
      width: 280,
    },
  },

  // Backdrop overlay for mobile
  backdrop: {
    position: "fixed",
    top: "calc(64px + env(safe-area-inset-top))",
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 1250,
    transition: "opacity 0.3s ease",
    touchAction: "auto",
    WebkitTapHighlightColor: "transparent",
  },

  contentArea: {
    flex: 1,
    overflowY: "auto",
    overflowX: "hidden",
    padding: "10px",
    transition: "margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    backgroundColor: theme.palette.background.default,
    [theme.breakpoints.up("md")]: {
      marginLeft: 0,
    },
    [theme.breakpoints.down("sm")]: {
      padding: "16px",
    },
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      background: theme.palette.divider,
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: theme.palette.text.secondary,
    },
  },
}));
